import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ spacing, palette, breakpoints }) => ({
	root: {
		overflow: 'hidden'
	},
	flexGrow: {
		flex: 1
	},
	monthContainer: {
		padding: spacing(1),
		display: 'flex'
	},
	moreButton: {
		padding: spacing(1),
		[breakpoints.up('sm')]: {
			marginLeft: spacing(-7.5)
		}
	},
	morePopover: {
		padding: spacing(2, 3)
	},
	setupBudgetsButton: {
		margin: spacing(3),
		display: 'flex',
		justifyContent: 'center'
	},
	overallBar: {
		height: spacing(1),
		'& > div': {
			transition: 'transform .8s linear'
		}
	},
	bar: {
		flex: '1 1 auto',
		border: '1px solid',
		borderRadius: 10,
		height: 12,
		backgroundColor: 'transparent',
		'& > div': {
			transition: 'transform .8s linear'
		},
		[breakpoints.up('sm')]: {
			margin: spacing(0, 1)
		}
	},
	list: {
		padding: spacing(0, 0, 0),
		justifySelf: 'flex-end',
		flex: '1'
	},
	listItemTop: {
		padding: spacing(2, 3, 0.25)
	},
	listItemMiddle: {
		padding: spacing(0.5, 3)
	},
	listItemBottom: {
		padding: spacing(0.25, 3, 1.5)
	},
	listItemBar: {
		padding: spacing(2.25, 3, 1.25)
	},
	listItemTotal: {
		padding: spacing(1.5, 3)
	},
	itemTextLeft: {
		marginRight: 'auto',
		flex: 'none',
		minWidth: '25%',
		margin: 0,
		'& > span': {
			fontSize: '0.875rem',
			fontWeight: 500
		}
	},
	itemTextRight: {
		textAlign: 'right',
		minWidth: '25%',
		flex: 'none',
		margin: 0,
		'& > span': {
			fontWeight: 500
		}
	},
	totalItemText: {
		'& > span': {
			fontSize: '0.875rem',
			fontWeight: 400,
			[breakpoints.up('sm')]: {
				fontSize: '0.95rem',
				letterSpacing: '0.02em'
			}
		},
		'& > p': {
			fontSize: '1rem',
			fontWeight: 500,
			lineHeight: 1.5,
			color: 'rgba(0, 0, 0, 0.87)',
			[breakpoints.up('sm')]: {
				fontSize: '1.1rem',
				letterSpacing: '0.02em'
			}
		}
	},
	plannedIncomeWrapper: {
		display: 'flex',
		justifyItems: 'center',
		justifyContent: 'flex-end',
		'& svg': {
			width: '.9em',
			height: '.9em',
			fill: palette.text.primary
		},
		'& button': {
			padding: 3,
			marginTop: -3,
			marginLeft: 1
		}
	}
}));
